import { css } from "@emotion/css";
import { LegacyCard, Tooltip } from "@octopusdeploy/design-system-components";
import { borderRadius, colorScales, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { LinkHref } from "@octopusdeploy/portal-routes";
import type React from "react";
import InternalLink from "~/components/Navigation/InternalLink/InternalLink";
interface ComplianceReportCardProps {
    onClick?: () => void;
    href?: LinkHref;
    icon: React.ReactNode;
    header: string;
    description: string;
}
export function ComplianceReportCard({ description, icon, header, href, onClick }: ComplianceReportCardProps) {
    const disabled = href === undefined && onClick === undefined;
    const card = (<LegacyCard onClick={onClick} link={href ? <InternalLink to={href}/> : undefined} logo={<div className={disabled ? styles.iconWrapperDisabled : styles.iconWrapper}>
                    <div className={styles.icon}>{icon}</div>
                </div>} header={<div className={styles.header}>{header}</div>} content={description} className={styles.card(disabled)} contentClassName={styles.content} leftAlign={true} isDisabled={disabled}/>);
    return <div className={styles.cardWrapper}>{disabled ? <Tooltip content="Coming soon">{card}</Tooltip> : card}</div>;
}
const styles = {
    cardWrapper: css({
        display: "flex",
        flex: "1 1 auto",
        minWidth: "260px",
        maxWidth: "320px",
        "@media (min-width: 600px)": {
            minWidth: "280px",
        },
    }),
    header: css({
        font: text.body.bold.large,
        margin: 0,
        marginBottom: space[2],
        "@media (max-width: 600px)": {
            marginLeft: -8,
        },
    }),
    content: css({
        "&&": {
            width: "auto",
            font: text.body.regular.xSmall,
            color: themeTokens.color.text.secondary,
            margin: 0,
            display: "block",
            opacity: 0.8,
        },
    }),
    icon: css({
        lineHeight: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }),
    iconWrapperDisabled: css({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: 48,
        height: 48,
        backgroundColor: colorScales.blue[400],
        borderRadius: borderRadius.medium,
        marginBottom: space[4],
        marginTop: 0,
        opacity: 0.6,
    }),
    iconWrapper: css({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: 48,
        height: 48,
        backgroundColor: colorScales.blue[400],
        borderRadius: borderRadius.medium,
        marginBottom: space[4],
        marginTop: 0,
    }),
    card: (disabled: boolean) => css({
        "&&": {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            width: "100%",
            gap: space[4],
            margin: 0,
            padding: space[16],
            paddingTop: space[12],
            borderRadius: borderRadius.large,
            backgroundColor: disabled ? themeTokens.color.background.disabled : undefined,
            cursor: disabled ? "auto" : "pointer",
            "&:hover": disabled
                ? {
                    boxShadow: themeTokens.shadow.small,
                    backgroundColor: themeTokens.color.background.disabled,
                }
                : {
                    boxShadow: themeTokens.shadow.medium,
                },
        },
    }),
};
